/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserCreateRequest {
  username: string;
  roleId?: string | null;
  admin?: boolean;
  disabled?: boolean;
  managed?: boolean;
  externalId?: string | null;
  password?: string | null;
}

export function UserCreateRequestFromJSON(json: any): UserCreateRequest {
  return UserCreateRequestFromJSONTyped(json);
}

export function UserCreateRequestFromJSONTyped(json: any): UserCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    username: json["username"],
    roleId: json["role_id"],
    admin: json["admin"],
    disabled: json["disabled"],
    managed: json["managed"],
    externalId: json["external_id"],
    password: json["password"],
  };
}

export function UserCreateRequestToJSON(
  value: UserCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    username: value.username,
    role_id: value.roleId,
    admin: value.admin,
    disabled: value.disabled,
    managed: value.managed,
    external_id: value.externalId,
    password: value.password,
  };
}
